import { IReduxAction, actionGenerator } from '../../utils/actions';

export const SET_RECOMMENDED_PACKAGE_CHECKOUT_FILL_BALANCE = 'SET :: RECOMMENDED_PACKAGE :: CHECKOUT_FILL_BALANCE';

export type TSetRecommendedPackageCheckoutFillBalanceAction = IReduxAction<
  typeof SET_RECOMMENDED_PACKAGE_CHECKOUT_FILL_BALANCE,
  boolean
>;

export const setRecommendedPackageCheckoutFillBalance = actionGenerator<
  typeof SET_RECOMMENDED_PACKAGE_CHECKOUT_FILL_BALANCE,
  boolean
>(SET_RECOMMENDED_PACKAGE_CHECKOUT_FILL_BALANCE);
